<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-xl-12">
            <div class="card-box">
                
                <div class="form-row">
                    
                    <div class="form-group col-md-5">
                            <label class="col-form-label">
                                <strong>{{$t('string.msg.dashboard.orders.period')}}</strong> 
                            </label>
                            <select v-model="nDays" @change="onChangeDay()"  class="form-control">
                                <option :value="1" selected> {{$t('string.msg.dashboard.orders.change.one.day')}}</option>
                                <option :value="2"> {{$t('string.msg.dashboard.orders.change.two.day')}}</option>
                                <option :value="3"> {{$t('string.msg.dashboard.orders.change.three.day')}}</option>
                                <option :value="7"> {{$t('string.msg.dashboard.orders.change.seven.day')}}</option>
                                <option :value="28"> {{$t('string.msg.dashboard.orders.change.twentyeight.day')}}</option>
                            </select>
                    </div>
                </div>

                <div v-if="items.length == 0" class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">{{$t('string.msg.dashboard.no.orders')}}</h5>
                        <p class="card-text">{{$t('string.msg.dashboard.no.orders.fleet.driver.description')}}</p>
                    </div>
                </div>

                <div v-if="items.length > 0" class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.service.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.date.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.dashboard.orders.table.company.title')}}</th>
                                <th class="border-top-0">{{$t('string.msg.modal.orders.price')}}</th>
                                <th class="border-top-0">{{$t('string.msg.modal.orders.status')}}</th>
                                <th class="border-top-0"></th><th class="border-top-0"></th>
                            </tr>
                        </thead>
                         <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer">
                            <tr v-if="item.statusOrder.toUpperCase() != 'CLOSED' && item.statusOrder.toUpperCase() == 'WAITING_FOR_RESPONSE' && item.statusOrder.toUpperCase() != 'REJECTED'">
                                <td>
                                    <span v-if="item.serviceFamilies">
                                        {{camelize(item.serviceFamilies.name)}}
                                    </span>
                                </td>
                                <td >
                                    <span v-if="item.dateOrder">
                                         {{new Date(item.dateOrder).toLocaleDateString()}} - {{new Date(item.dateOrder).toLocaleTimeString()}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.company && item.company.fantasyName">
                                        {{camelize(item.company.fantasyName)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.total">
                                        {{ $t('string.msg.current.label') + item.total.toFixed(2)}}
                                    </span>
                                    <span v-else>
                                        {{ $t('string.msg.current.initial.label') }} 
                                    </span> 
                                </td>
                                <td>
                                    <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'WAITING_FOR_RESPONSE'" style="background-color:#fabc2a; color:black">
                                        <span class="ml-2 mr-2">{{ $t(item.statusOrder.toUpperCase())}}</span>
                                    </span>
                                    <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'CLOSED'"  style="background-color:gray; color:white">
                                        <span class="ml-2 mr-2"> {{$t(item.statusOrder.toUpperCase())}}</span>
                                    </span>
                                    <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'PAID'" style="background-color:green; color:white">
                                        <span class="ml-2 mr-2">{{ $t(item.statusOrder.toUpperCase())}}</span>
                                    </span>
                                    <span class="status-order" v-else-if="item.statusOrder.toUpperCase() == 'IN_PROGRESS'" style="background-color:blue; color:white">
                                        <span class="ml-2 mr-2">{{ $t(item.statusOrder.toUpperCase())}}</span>
                                    </span>
                                </td>
                                <td>
                                    <span class="text-center" v-if="item.statusOrder.toUpperCase() == 'PAID'">
                                            <button class="btn btn-danger w-100"  @click="download(item)">{{$t('string.msg.download.orders.pdf')}}</button>
                                        <qrcode-vue :value="item._id" :size="size" level="H" ref="qrCodeUrl"></qrcode-vue>
                                    </span> 
                                    <span v-else-if="item.statusOrder.toUpperCase() != 'PAID' && checkReject(item)">
                                        <button  @click="selectItem(item)" class="btn btn-danger w-100">{{$t('string.msg.dashboard.orders.btn.answer')}}</button>
                                    </span>
                                </td>
                                <td>
                                    <span v-if="checkReject(item)">
                                        <button v-on:click="confirmArchive(item)" class="text-dark-gray btn btn-warning w-50">{{$t('string.msg.order.status.reject')}}</button>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Modal :order="order" :trucks="trucks" v-on:confirmation-return="updateScreen"/>
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" :order="orderSelected" v-on:confirmation-return="archive" />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtListOrdersServices';
import Spinner from '../../../../../../components/layout/Spinner';
import Toast from '../../../../../../components/layout/Toast';
import Confirmation from './Modal/Reject';
import Modal from './Modal/ModalOrderService';
import jsPDF from 'jspdf';
import QrcodeVue from 'qrcode.vue';
import Vue from 'vue'
import crono from 'vue-crono';
Vue.use(crono);

export default {
  name: 'ListOrdersServices',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast,
    Modal,
    Confirmation
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        items: [],
        order:{},
        orderSelected: null,
        timer: '',
        trucks:null,
        nDays:1,
        value: '0',
        size: 100,
        filters: {
            typeOrder: "SERVICES",
            companyRequest: null
        }   
      }
  },
  methods: Controller.methods,
  created() {
  },
  mounted(){
        Controller.init(this);
        this.filters.companyRequest = this.$session.get('user').companyUser.company._id;
        this.filter();
  },
  cron:{
        time: 30000,
        method: 'load'
    },
  destroyed(){
     clearInterval(this.timer);
  },
  beforeDestroy () {
    clearInterval(this.timer);
  }
}
</script>

<style>
</style>
